import classNames from 'classnames'
import React from 'react'
import { useOnClickOutside } from '../../utils/hooks'
import { AutocompleteOptions } from '../AutocompleteOptions/AutocompleteOptions'
import './InputAutoComplete.sass'

interface InputAutoCompleteProps {
  className?: string
  name?: string
  title?: string
  required?: boolean
  placeholder?: string
  callback: (props: any) => Promise<any>
  value: string
  setValue: (value: string) => void
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  handleSubmit: (value: string) => void
  [x: string]: any
}

export const InputAutoComplete: React.FC<InputAutoCompleteProps> = ({
  className,
  name,
  title,
  required,
  placeholder,
  callback,
  value,
  setValue,
  onChange,
  handleSubmit,
  ...rest
}) => {
  const divRef = React.useRef<HTMLDivElement>(null)
  const inputRef = React.useRef<HTMLInputElement>(null)
  const controlWrapperPrefixCls = 'autocomplete-wrapper'
  const inputClassName = `${controlWrapperPrefixCls}__input`
  const optionClassName = `${controlWrapperPrefixCls}__options`
  const controlClassName = classNames(controlWrapperPrefixCls, {
    [`${className}`]: className,
  })

  const [optionsList, setOptionList] = React.useState<string[]>([])
  const [isLoading, setIsLoading] = React.useState<boolean>(false)
  const [isError, setIsError] = React.useState<boolean>(false)
  const [isFocused, setIsFocused] = React.useState<boolean>(false)

  const handleSetValue = (value: string) => {
    setValue(value)
  }

  const applyTagValue = (option?: string) => {
    handleSubmit(option ? option : value)
    setIsFocused(false)
    handleSetValue(option ? option : value)
  }

  const handleClickValue = (option: string) => {
    applyTagValue(option)
  }

  const handleBlur = () => {
    setIsFocused(false)
    // applyTagValue()
  }

  // const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
  //   if (e.key === 'Tab' || e.key === 'Enter') {
  //     applyTagValue()
  //   }
  // }

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    e.currentTarget.focus()
    setIsFocused(true)
  }

  useOnClickOutside(divRef, handleBlur)

  React.useEffect(() => {
    let isSubscribe = true
    const handler = setTimeout(async () => {
      try {
        setIsError(false)
        setIsLoading(true)
        const values = await callback(value)
        if (isSubscribe) {
          setOptionList(values)
        }
      } catch {
        setIsError(true)
      }
      setIsLoading(false)
    }, 500)
    return () => {
      isSubscribe = false
      clearTimeout(handler)
    }
  }, [value, callback])

  return (
    // <div className={controlClassName} ref={divRef} onKeyDown={handleKeyPress}>
    <div className={controlClassName} ref={divRef}>
      {title && <label htmlFor={name}>{title}</label>}
      <input
        type='text'
        ref={inputRef}
        id={name}
        className={inputClassName}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        onFocus={handleFocus}
        {...rest}
      />
      {isFocused && optionsList.length > 0 && !isError && (
        <AutocompleteOptions
          className={optionClassName}
          options={optionsList}
          isLoading={isLoading}
          setValue={handleClickValue}
        />
      )}
    </div>
  )
}
